export const listUserProfilesFragment = /* GraphQL */ `
    id
    owner
    memberStatus
    cognitoId
    applicants {
      citizenshipCountry
      birthCountry
      dateOfBirth
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
        }
        email
      }
      homeAddress {
        streets
        city
        state
        postal
        country
      }
      mailingAddress {
        streets
        city
        state
        postal
        country
      }
      employment {
        employmentStatus
        employerName
        position
        yearsEmployed
        businessAddress {
          streets
          city
          state
          postal
          country
        }
      }
      foreignTaxIdCountry
      foreignTaxIdNumber
      socialSecurityNumber
      visaType
      visaExpirationDate
      permanentResident
      identificationType
      identificationNumber
      countryOfIssue
      identificationIssueDate
      identificationExpirationDate
      identificationS3Uri
      identificationSnapId
    }
    contactDetails {
      givenName
      familyName
      phone {
        phoneType
        phoneNumber
      }
      email
    }
    homeAddress {
      streets
      city
      state
      postal
      country
    }
    employment {
      employmentStatus
      employerName
      position
      yearsEmployed
      businessAddress {
        streets
        city
        state
        postal
        country
      }
    }
    mailingAddress {
      streets
      city
      state
      postal
      country
    }
    entityAccountInformation {
      entityName
      entityTaxId
      stateOfOrigin
      mailingPreference
      isPabAccount
      isUSEntity
      issuerDirectCommunicationCode
      isExemptLegalCustomer
      exemption
      legalEntityIdentifier
      entityOfficers {
        familyName
        givenName
        dateOfBirth
        address {
          streets
          city
          state
          postal
          country
        }
        socialSecurityNumber
        identificationNumber
      }
      beneficialOwners {
        familyName
        givenName
        dateOfBirth
        address {
          streets
          city
          state
          postal
          country
        }
        socialSecurityNumber
        identificationNumber
      }
    }
    trustedContact {
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
        }
        email
      }
      address {
        streets
        city
        state
        postal
        country
      }
    }
    investmentProfile {
      riskStandardOptions
      uncoveredOptionWriters
      investmentExperience
      riskTolerance
      investmentObjective
      minTotalNetWorthUSD
      minAnnualIncomeUSD
      minLiquidNetWorthUSD
      maxTotalNetWorthUSD
      maxAnnualIncomeUSD
      maxLiquidNetWorthUSD
      timeHorizon
      liquidityNeeds
      stockTradesPerYear
      optionsTradesPerYear
      commonditiesTradesPerYear
      corporateBondsTradesPerYear
      municipalBondsTradesPerYear
      governmentBondsTradesPerYear
      fundsTradesPerYear
      marginAccountTradesPerYear
    }
    dateOfBirth
    socialSecurityNumber
    citizenshipCountry
    catAccountholderType
    customerType
    accountType
    politicallyExposed {
      politicalOrganization
      immediateFamily
    }
    controlPersonSymbols
    affiliated {
      firmName
      affiliatedApproval
      docS3Key
    }
    customerAccountAgreement
    privacyPolicy
    accounts {
      items {
        id
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
          }
          createdAt
          updatedAt
          balanceAccountInformationId
        }
        permissions {
          id
          accountNumber
          owner
          systemAccess
          equityTrading
          optionsTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          achDeposit
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          createdAt
          updatedAt
          userPermissionsAccountInformationId
        }
        positions {
          items {
            id
            accountNumber
            owner
            underlying
            pricePaid
            quantity
            marginRequirement
            strategy
            positionLegs {
              side
              quantity
              ratioQuantity
              pricePaid
              legType
              marginRequirement
              expiration
              strike
            }
            status
            createdAt
            updatedAt
            accountInformationPositionsId
          }
          nextToken
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              accountType
              createdAt
              updatedAt
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
              }
              nextToken
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
          }
          nextToken
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
          }
          nextToken
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
          }
          nextToken
        }
        achRelationship {
          id
          accountNumber
          owner
          achRelationshipStatic {
            id
            plaidAccountId
            accountNumber
            owner
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              achRelationship {
                id
                accountNumber
                owner
                deleted
                nickname
                microDepositTries
                microDeposits
                microDepositStatus
                reissueTries
                reissue
                createdAt
                updatedAt
                achRelationshipAchRelationshipStaticId
                achRelationshipAccountInformationId
              }
              relationshipId
              amount
              message
              memo
              reason
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
            }
            nextToken
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
      }
      nextToken
    }
    accountNumbers
    status
    createdAt
    updatedAt
`;
